import * as React from 'react';
import './ReturnsRmaTable.scss';
import ReturnsRmaRow from '../ReturnsRmaRow';
import { IRmaModalData } from 'src/pages/ReturnsView/ReturnsView';
import localeFormatingInstance from 'src/translation/localeFormating';
import { IReturnDetail } from 'src/services/returns/typings';

interface IReturnsRmaTableProps {
  rmaData: IReturnDetail[];
  rmaDataFixed: IReturnDetail[];
  rmaAction: string;
  handleChangeRmaData: (id: number) => void;
  handleChangeRmaDataInput: (value: IReturnDetail[]) => void;
  handleSelectedTypeOfItemEligible: (type: string) => void;
  handleCloseModal: () => void;
  selectTab: (index: number) => void;
  typeOfItemStatus: string;
  clearEligibleFilters: () => void;
  getRmaLists: () => void;
  totalShippingCharge:number;
  t?: any;
}

const ReturnsRmaTable: React.FC<IReturnsRmaTableProps> = props => {
  const {
    rmaData,
    rmaAction,
    handleChangeRmaData,
    handleChangeRmaDataInput,
    handleSelectedTypeOfItemEligible,
    handleCloseModal,
    selectTab,
    rmaDataFixed,
    typeOfItemStatus,
    clearEligibleFilters,
    getRmaLists,
    totalShippingCharge,
    t
  } = props;

  const calculateEstimated = (): number => {
    let result = 0;
    rmaData.forEach(item => {
      result += item.returnAmount;
    });

    if(totalShippingCharge>0){
      return result-totalShippingCharge;
    }else{
      return result;
    }
  };

  const handleGoToEligible = () => {
    clearEligibleFilters();
    if (typeOfItemStatus === 'part') {
      handleSelectedTypeOfItemEligible('part');
    } else {
      handleSelectedTypeOfItemEligible('usedCore');
    }
    handleCloseModal();
    selectTab(0);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    getRmaLists();
  };

  return (
    <div className="rp-returns-rma-table">
      <div className="container-fluid">
        <div className="row rp-returns-rma-table-headers">
          <div className="d-flex col-16">
            <p className="rp-returns-rma-table-header">
              {t('myReturns.partNo')}
            </p>
          </div>
          <div className="d-flex col-14">
            <p className="rp-returns-rma-table-header">
              {t('myReturns.invoiceNo')}
            </p>
          </div>
          <div className="d-flex col-9">
            <p className="rp-returns-rma-table-header">
              {t('myReturns.price')}
            </p>
          </div>
          <div className="d-flex justify-content-center col-11">
            <p className="rp-returns-rma-table-header">
              {t('myReturns.returnQty')}
            </p>
          </div>
          <div className="d-flex justify-content-center col-12">
            <p className="rp-returns-rma-table-header">
              {t('myReturns.restockingFee')}
            </p>
          </div>
          <div className="d-flex justify-content-center col-12">
            <p className="rp-returns-rma-table-header">
              {t('myReturns.creditAmount')}
            </p>
          </div>
          <div className="d-flex col-17">
            <p className="rp-returns-rma-table-header">
              {t('myReturns.reasonReference')}
            </p>
          </div>
        </div>
      </div>
      <div className="rp-returns-rma-table-row-container">
        {rmaData.map((rma, index) => (
          <ReturnsRmaRow
            key={rma.id}
            action={rmaAction}
            rmaItemFixed={rmaDataFixed[index]}
            rmaItem={rma}
            rmaData={rmaData}
            handleChangeRmaData={handleChangeRmaData}
            handleChangeRmaDataInput={handleChangeRmaDataInput}
          />
        ))}
      </div>
      <div className="container-fluid">
        <div className="row rp-returns-rma-table-estimated-container">
          <div className="col-12">
            <p className="rp-returns-rma-table-estimated">
              {`${t(
                'myReturns.totalEstimatedCredit'
              )} ${localeFormatingInstance.formatCurrency(
                calculateEstimated()
              )}`}
            </p>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row rp-returns-rma-table-go-to-eligible">
          <div className="col-12">
            <p className="rp-returns-rma-table-go-to-eligible-text">
              {t('myReturns.toAddMorePartsTxt')}{' '}
              <span onClick={handleGoToEligible}>
                {t('myReturns.eligibleReturns')}
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReturnsRmaTable;
